import { useState } from "react";
import FaiBox from "MuiComponents/FaiBox";
import FaiTypography from "MuiComponents/FaiTypography";
import theme from "assets/theme";
import { Form, Formik, FormikProps } from "formik";
import { Grid } from "@mui/material";
import FormField from "components/FormField";
import FaiButton from "MuiComponents/FaiButton";
import FaiSelect from "MuiComponents/FaiSelect";
import Axios from "services/api/config";
import { setBankInfo } from "services/api/routes/Auth";
import PageHeader from "../components/PageHeader";

interface InitialObject {
	bankName: string;
	bankAccountNumber: string;
	accountHolderName: string;
	ifscCode: string;
	accountType: string;
}

function BankDetails({ onNextStep = () => {} }) {
	const { palette } = theme;
	const [initialObject] = useState<InitialObject>({
		bankName: "",
		bankAccountNumber: "",
		accountHolderName: "",
		ifscCode: "",
		accountType: "",
	});

	const [isLoading, setLoading] = useState(false);

	const onSubmit = async (data: object) => {
		try {
			setLoading(true);
			const { data } = await Axios({
				...setBankInfo,
				data: {},
			});
			console.log("data", data);
			// You can trigger the next step here if necessary
			onNextStep();
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<>
			<FaiBox className="p-6 rounded-b-lg" bgColor={palette.white.main}>
				<FaiBox className={"coupon-form-content"}>
					<PageHeader
						title="Bank Details"
						content="Please fill in your bank details to ensure smooth and timely payments."
					/>

					<Formik
						initialValues={initialObject}
						enableReinitialize={true}
						validateOnBlur={true}
						validateOnChange={true}
						onSubmit={onSubmit}
					>
						{(props: FormikProps<InitialObject>) => {
							const {
								// handleSubmit,
								// setFieldValue,
								handleChange,
								handleBlur,
								values,
								touched,
								// isValid,
								errors,
							} = props;
							return (
								<Form className="py-4">
									<Grid container spacing={2}>
										<Grid item xs={12} sm={6}>
											<FaiBox xs={12} sm={6}>
												<FormField
													label={"Account Holder Name"}
													name={"accountHolderName"}
													placeholder={"Enter Account Holder Name"}
													value={values.accountHolderName}
													onChange={handleChange}
													onBlur={handleBlur}
													error={
														touched.accountHolderName &&
														Boolean(errors.accountHolderName)
													}
													helperText={
														touched.accountHolderName &&
														errors.accountHolderName
													}
													autoFocus
													isRequired
												/>
											</FaiBox>
										</Grid>

										<Grid item xs={12} sm={6}>
											<FaiBox xs={12} sm={6}>
												<FormField
													label={"Account Number"}
													name={"bankAccountNumber"}
													placeholder={"Enter Bank Account Number"}
													value={values.bankAccountNumber}
													onChange={handleChange}
													onBlur={handleBlur}
													error={
														touched.bankAccountNumber &&
														Boolean(errors.bankAccountNumber)
													}
													helperText={
														touched.bankAccountNumber &&
														errors.bankAccountNumber
													}
													isRequired
												/>
											</FaiBox>
										</Grid>

										<Grid item xs={12} sm={6}>
											<FaiBox my={1} display="inline-block">
												<FaiTypography
													component="label"
													variant="caption"
													className="!text-base leading-6 !font-medium"
													textTransform="capitalize"
													isRequired
												>
													Account Type
												</FaiTypography>
											</FaiBox>
											<FaiSelect
												placeholder={"Account Type"}
												name={"accountType"}
												options={[
													{ value: "savings", label: "Savings" },
													{ value: "current", label: "Current" },
												]}
												isRequired
											/>
										</Grid>

										<Grid item xs={12} sm={6}>
											<FaiBox my={1}>
												<FormField
													label={"Bank Name"}
													name={"bankName"}
													placeholder={"Enter Bank Name"}
													value={values.bankName}
													onChange={handleChange}
													onBlur={handleBlur}
													error={touched.bankName && Boolean(errors.bankName)}
													helperText={touched.bankName && errors.bankName}
													isRequired
												/>
											</FaiBox>
										</Grid>

										<Grid item sm={12} xs={12}>
											<FaiBox mb={1}>
												<FormField
													multiline
													rows={5}
													label={"Bank address"}
													name={"bankAddress"}
													placeholder={"Enter Bank Address"}
													isRequired
												/>
											</FaiBox>
										</Grid>

										<Grid item xs={12} sm={6}>
											<FaiBox xs={12} sm={6}>
												<FormField
													label={"IFSC Code"}
													name={"ifscCode"}
													placeholder={"Enter Code"}
													value={values.ifscCode}
													onChange={handleChange}
													onBlur={handleBlur}
													error={touched.ifscCode && Boolean(errors.ifscCode)}
													helperText={touched.ifscCode && errors.ifscCode}
													note="Notes for IFSC code"
													isRequired
												/>
											</FaiBox>
										</Grid>
									</Grid>

									<FaiBox pt={"15px"}>
										<Grid container className="flex justify-end">
											<FaiButton
												color="primary"
												variant={"contained"}
												onClick={onNextStep}
												disabled={isLoading}
											>
												Continue
											</FaiButton>
										</Grid>
									</FaiBox>
								</Form>
							);
						}}
					</Formik>
				</FaiBox>
			</FaiBox>
		</>
	);
}
export default BankDetails;
